<template>
  <div class="channels">
    <v-container fluid>
      <v-row v-if="items">
        <v-col
          v-for="(item, index) in items"
          :key="index"
          :cols="12 / column"
          :class="index < items.length - 1 ? 'pa-2 pb-0' : 'pa-2'"
        >
          <v-card outlined>
            <v-card-text class="pa-0">
              <v-toolbar dense flat>
                <v-toolbar-title class="subtitle-1">
                  {{ item.channelName }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    v-if="item.imageUrl || item.content || item.logo"
                    @click="fnExpand(index)"
                    class="mr-1 pa-1"
                    icon
                    small
                  >
                    <v-avatar v-if="item.logo" size="18" tile>
                      <img :src="utils.checkFile(item.logo)" />
                    </v-avatar>
                    <v-avatar
                      v-else-if="item.imageUrl && !item.logo"
                      size="18"
                      tile
                    >
                      <img :src="utils.checkFile(item.imageUrl)" />
                    </v-avatar>
                    <v-icon v-else>mdi-file-eye</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="category == 'member'"
                    @click="fnMembers(item)"
                    icon
                    small
                  >
                    <v-icon>mdi-account-supervisor</v-icon>
                  </v-btn>
                  <v-btn v-else @click="fnContents(item)" icon small>
                    <v-icon>mdi-file-document-multiple-outline</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
            </v-card-text>
            <v-expand-transition>
              <v-card v-if="expanded[index]" color="grey lighten-5" tile flat>
                <v-card-text class="pa-0">
                  <v-list class="pa-0" dense tile>
                    <v-list-item
                      v-if="item.address"
                      @click="fnOpenMap(item)"
                      dense
                    >
                      <v-icon class="mr-2" small>mdi-map-marker</v-icon>
                      <v-list-item-title>
                        {{ item.address }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.tel"
                      @click="utils.dialPhone(item.tel)"
                      dense
                      class="d-flex justify-space-between"
                    >
                      <v-icon class="mr-2" small>mdi-phone-classic</v-icon>
                      <v-list-item-title>
                        {{ item.tel }}
                      </v-list-item-title>
                    </v-list-item>
                    <template v-if="item.businessScope">
                      <v-list-item dense>
                        <v-icon class="mr-2" small>mdi-tag-multiple</v-icon>
                        <v-list-item-title> 业务范围 </v-list-item-title>
                      </v-list-item>
                      <v-chip-group class="px-3 pb-3" column>
                        <v-chip
                          v-for="(chip, index) in utils.setJSON(
                            item.businessScope
                          )"
                          :key="index"
                          @click="fnViewContent(chip)"
                          label
                          small
                        >
                          {{ chip.title }}
                        </v-chip>
                      </v-chip-group>
                    </template>
                  </v-list>
                </v-card-text>
                <v-img
                  v-if="item.imageUrl"
                  @click="fnExpand(index)"
                  :src="utils.checkFile(item.imageUrl)"
                  aspect-ratio="1.5"
                  contain
                >
                </v-img>
                <v-card-text
                  @click="fnExpand(index)"
                  v-html="utils.checkBody(item.content)"
                ></v-card-text>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showMap">
      <TMarker
        :coords="coords"
        :label="pointLabel"
        :marker="marker"
        @showMap="showMap = false"
      ></TMarker>
    </v-dialog>
    <CLoading
      v-model="loading"
      :text="tipsText"
      :timeout="timeout"
      @closeDialog="loading = false"
    />
  </div>
</template>

<script>
// 自定义功能
import utils from "@/utils";
// 自定义组件
import CLoading from "@/components/c_loading";
import TMarker from "@/components/map/t_marker";
export default {
  name: "CChannels",
  props: {
    items: { type: Array, required: false, default: () => [] },
    category: { type: String, required: false, default: "member" },
    column: { type: Number, required: false, default: 1 },
  },
  components: {
    CLoading,
    TMarker,
  },
  data: () => ({
    utils: utils,
    defaultAvatar: null,
    expanded: [],
    coords: [],
    showMap: false,
    pointLabel: null,
    marker: null,
    loading: false,
    tipsText: "请稍候...",
    timeout: 1000,
  }),
  watch: {
    items(val) {
      this.expanded = val.map(() => {
        return false;
      });
    },
  },
  mounted() {
    this.defaultAvatar = require("@/assets/images/default_avatar.png");
    this.expanded = this.items.map(() => {
      return false;
    });
  },
  methods: {
    fnMembers(item) {
      this.$router.push(`/users?orgId=${item.id}`);
    },
    fnContents(item) {
      this.$router.push(`/contents?channelId=${item.id}`);
    },
    fnExpand(index) {
      var arr = [];
      this.expanded.forEach((item, i) => {
        if (index == i) {
          arr.push(!item);
        } else {
          arr.push(item);
        }
      });
      this.expanded = arr;
    },
    fnFilter(item) {
      this.$emit("setFilter", item);
    },
    fnSetOrg(item) {
      this.$emit("setOrg", item);
    },
    fnOpenMap(item) {
      if (!item.coords) {
        this.tipsText = "未录入坐标";
        this.loading = true;
        this.timeout = 3000;
      } else {
        // if (item.logo) {
        //   this.marker = utils.checkFile(item.logo);
        // } else if (item.imageUrl) {
        //   this.marker = utils.checkFile(item.imageUrl);
        // }
        this.pointLabel = item.channelName;
        this.coords = utils.setArray(item.coords);
        this.showMap = true;
      }
    },
    fnViewContent(chip) {
      this.$emit("viewContent", chip);
    },
  },
};
</script>
<style lang="scss">
p {
  text-indent: 2rem;
}
</style>